module.exports = __webpack_public_path__ + "static/remote-view-94dd533f6b70b5bd7e8a70d930bed27c.svg";